import React from "react";
import { Card as CardType } from "../types";
import Card from "./Card";
import CardSlot from "./CardSlot";

interface FoundationPileProps {
  cards: CardType[];
  isValidDestination: boolean;
  onClick: () => void;
}

export const FoundationPile: React.FC<FoundationPileProps> = ({
  cards,
  isValidDestination,
  onClick,
}) => {
  return (
    <CardSlot isValidDestination={isValidDestination} onClick={onClick}>
      {cards.length > 0 && <Card card={cards[cards.length - 1]} />}
    </CardSlot>
  );
};

export default FoundationPile;
